/* eslint-disable */

import React, { useState, useEffect, useRef, useMemo } from 'react';
import axios from 'axios';
// Deferred (expire/lot UI): restore when enabling master expire/lot fields
// import dayjs from 'dayjs';
// import 'dayjs/locale/th';
// import buddhistEra from 'dayjs/plugin/buddhistEra';
import { Link } from 'react-router-dom';
import {
  Table,
  Button,
  Space,
  Typography,
  Modal,
  Form,
  Input,
  InputNumber,
  message,
  Popconfirm,
  Select,
  Row,
  Col,
  Tag,
  Pagination,
} from 'antd';
import {
  TagOutlined,
  PlusOutlined,
  ImportOutlined,
  ReloadOutlined,
  FileExcelOutlined,
  EditOutlined,
  DeleteOutlined,
  EyeOutlined,
  SearchOutlined,
  UploadOutlined,
  ScanOutlined,
} from '@ant-design/icons';
import { useProductItemList } from './useProductItemList';
import { fetchAllProductItems } from './license-form/licenseApi';
import PageContainer from '../../components/PageContainer';
import CardProductDemo from '../../components/card-product/CardProductDemo';
import BarcodeScanner from '../../components/scanner/BarcodeScanner';
// Deferred (expire/lot UI): restore when enabling master expire/lot fields
// import { ResponsiveDatePicker } from '../../components/ResponsiveDatePicker/ResponsiveDatePicker';
import ProductImportModal from './ProductImportModal';
import './ConsoleProductItems.css';

// dayjs.extend(buddhistEra);
// dayjs.locale('th');

const { Title, Text } = Typography;

function ProductItem(props) {
  const [form] = Form.useForm();
  const imgfile1_Ref = useRef(null);
  const imgfile2_Ref = useRef(null);
  const imgfile3_Ref = useRef(null);

  const inputfile1_Ref = useRef(null);
  const inputfile2_Ref = useRef(null);
  const inputfile3_Ref = useRef(null);

  const [PreviewImage1, setPreviewImage1] = useState('/images/blank.png');
  const [PreviewImage2, setPreviewImage2] = useState('/images/blank.png');
  const [PreviewImage3, setPreviewImage3] = useState('/images/blank.png');
  const [PreviewIndex, setPreviewIndex] = useState(1);

  const [productcategory_selected, setProductCategory_Selected] = useState('all');
  const [filtertext, setFiltertext] = useState('');
  const [debouncedSearch, setDebouncedSearch] = useState('');
  const [page, setPage] = useState(1);
  const [exportLoading, setExportLoading] = useState(false);
  const pageSize = 50;

  const [productitem_selected, setProductItem_Selected] = useState({});
  const [productmode, setProductmode] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isImportModalOpen, setIsImportModalOpen] = useState(false);
  const [importFile, setImportFile] = useState(null);
  const [modalLoading, setModalLoading] = useState(false);
  const [preview_option, setPreview_Option] = useState({});
  const [viewMode, setViewMode] = useState('list'); // 'list' or 'gallery'
  const [isScannerOpen, setIsScannerOpen] = useState(false);
  const [isSearchScannerOpen, setIsSearchScannerOpen] = useState(false);

  const [imageFile1, setImageFile1] = useState(null);
  const [imageFile2, setImageFile2] = useState(null);
  const [imageFile3, setImageFile3] = useState(null);

  const { productitem_list, productcategory_list, total, loading, reload } = useProductItemList({
    app_hostname: props.app_hostname,
    permitdata: props.permitdata,
    page,
    pageSize,
    search: debouncedSearch,
    categoryId: productcategory_selected,
  });

  const selectedCategoryId = Form.useWatch('productcategory_id', form);
  const selectedProductLicenses = useMemo(() => {
    const category = (productcategory_list || []).find(
      (item) => item.productcategory_id === selectedCategoryId,
    );
    if (category) {
      return category.drug_licenses || [];
    }
    return productitem_selected?.drug_licenses || [];
  }, [productcategory_list, selectedCategoryId, productitem_selected]);

  const getProductImageUrl = (record, imageIndex = 1) => {
    const preview = record?.[`img${imageIndex}_preview`] || record?.img1_preview;
    if (preview) return preview;

    const imgKey = record[`img${imageIndex}_key`];
    if (!record?.productitem_id || !imgKey) {
      return '/images/blank.png';
    }
    return (
      props.app_hostname +
      '/api/product/file/productitem/' +
      record.productitem_id +
      '/' +
      record.productitem_id +
      '-' +
      imageIndex +
      '-' +
      imgKey +
      '.jpg'
    );
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(filtertext.trim());
      setPage(1);
    }, 300);
    return () => clearTimeout(timer);
  }, [filtertext]);

  useEffect(() => {
    if (productcategory_selected === '' && productcategory_list?.length > 0) {
      setProductCategory_Selected('all');
    }
  }, [productcategory_list, productcategory_selected]);

  function handleAdd() {
    setProductmode('add');
    setProductItem_Selected({});
    form.resetFields();
    const defaultCategory =
      productcategory_selected && productcategory_selected !== 'all'
        ? productcategory_selected
        : productcategory_list?.[0]?.productcategory_id;
    form.setFieldsValue({
      productcategory_id: defaultCategory,
      productitem_id: '-',
    });
    setPreviewIndex(1);
    setPreviewImage1('/images/blank.png');
    setPreviewImage2('/images/blank.png');
    setPreviewImage3('/images/blank.png');
    setImageFile1(null);
    setImageFile2(null);
    setImageFile3(null);
    setIsModalOpen(true);
  }

  function handleEdit(record) {
    setProductmode('edit');
    setProductItem_Selected(record);
    form.setFieldsValue({
      productcategory_id: record.productcategory_id,
      productitem_id: record.productitem_id,
      productitem_name: record.productitem_name,
      productitem_inter: record.productitem_inter,
      productitem_desc: record.productitem_desc,
      productitem_barcode: record.productitem_barcode,
      // Deferred (expire/lot UI)
      // productitem_expiredate:
      //   record.productitem_expiredate && dayjs(record.productitem_expiredate).isValid()
      //     ? dayjs(record.productitem_expiredate)
      //     : undefined,
      // productitem_lot: record.productitem_lot,
      productitem_width: record.productitem_width,
      productitem_height: record.productitem_height,
      productitem_deep: record.productitem_deep,
      productitem_weight: record.productitem_weight,
    });

    setPreviewIndex(1);
    setPreviewImage1(getProductImageUrl(record, 1));
    setPreviewImage2(getProductImageUrl(record, 2));
    setPreviewImage3(getProductImageUrl(record, 3));
    setImageFile1(null);
    setImageFile2(null);
    setImageFile3(null);
    setIsModalOpen(true);
  }

  async function handleSubmit(values) {
    setModalLoading(true);

    let file1 = imageFile1;
    let file2 = imageFile2;
    let file3 = imageFile3;

    if (productmode === 'add') {
      try {
        const response = await fetch((process.env.PUBLIC_URL || '') + '/images/placeholder.webp');
        const blob = await response.blob();
        const placeholderFile = new File([blob], 'placeholder.webp', { type: 'image/webp' });

        if (!file1) file1 = placeholderFile;
        if (!file2) file2 = placeholderFile;
        if (!file3) file3 = placeholderFile;
      } catch (error) {
        console.error('Failed to load placeholder image:', error);
      }
    }

    const formData = new FormData();
    formData.append('productcategory_name', values.productcategory_id);
    formData.append('productitem_id', values.productitem_id);
    formData.append('productitem_name', values.productitem_name);
    formData.append('productitem_inter', values.productitem_inter);
    formData.append('productitem_desc', values.productitem_desc);
    formData.append('productitem_barcode', values.productitem_barcode);
    // Deferred (expire/lot UI): restore form values when re-enabling fields
    // formData.append(
    //   'productitem_expiredate',
    //   values.productitem_expiredate && dayjs(values.productitem_expiredate).isValid()
    //     ? dayjs(values.productitem_expiredate).format('YYYY-MM-DD')
    //     : '',
    // );
    // formData.append('productitem_lot', values.productitem_lot || '');
    // Pass through existing values on edit so API does not clear them while UI is hidden
    formData.append(
      'productitem_expiredate',
      productmode === 'edit' ? productitem_selected?.productitem_expiredate || '' : '',
    );
    formData.append(
      'productitem_lot',
      productmode === 'edit' ? productitem_selected?.productitem_lot || '' : '',
    );
    formData.append('productitem_width', values.productitem_width);
    formData.append('productitem_height', values.productitem_height);
    formData.append('productitem_deep', values.productitem_deep);
    formData.append('productitem_weight', values.productitem_weight);
    formData.append('username', props.permitdata.username);

    if (file1) formData.append('productimage1', file1);
    if (file2) formData.append('productimage2', file2);
    if (file3) formData.append('productimage3', file3);

    axios
      .post(props.app_hostname + '/api/product/item/' + productmode, formData, {
        headers: {
          Accept: 'application/json',
          Authorization: 'Bearer ' + props.permitdata.token,
        },
      })
      .then((response) => {
        setModalLoading(false);
        if (response.data.status === 'OK') {
          reload();
          setIsModalOpen(false);
          message.success('บันทึกรายการสินค้าสำเร็จ');
        } else {
          message.error(response.data.message || 'เกิดข้อผิดพลาด');
        }
      })
      .catch((err) => {
        setModalLoading(false);
        message.error(err.message || 'เชื่อมต่อเซิร์ฟเวอร์ล้มเหลว');
      });
  }

  async function handleDelete(record) {
    const formData = new FormData();
    formData.append('productitem_id', record.productitem_id);
    axios
      .post(props.app_hostname + '/api/product/item/delete', formData, {
        headers: {
          Accept: 'application/json',
          Authorization: 'Bearer ' + props.permitdata.token,
        },
      })
      .then((response) => {
        if (response.data.status === 'OK') {
          reload();
          message.success('ลบรายการสินค้าสำเร็จ');
        } else {
          message.error(response.data.message || 'เกิดข้อผิดพลาด');
        }
      })
      .catch((err) => {
        message.error(err.message || 'เชื่อมต่อเซิร์ฟเวอร์ล้มเหลว');
      });
  }

  const handleImageChange1 = (event) => {
    const file = event.target.files[0];
    if (file) {
      setImageFile1(file);
      setPreviewImage1(URL.createObjectURL(file));
    }
  };

  const handleImageChange2 = (event) => {
    const file = event.target.files[0];
    if (file) {
      setImageFile2(file);
      setPreviewImage2(URL.createObjectURL(file));
    }
  };

  const handleImageChange3 = (event) => {
    const file = event.target.files[0];
    if (file) {
      setImageFile3(file);
      setPreviewImage3(URL.createObjectURL(file));
    }
  };

  function preview_back() {
    if (PreviewIndex > 1) {
      setPreviewIndex(PreviewIndex - 1);
    }
  }

  function preview_next() {
    if (PreviewIndex < 3) {
      setPreviewIndex(PreviewIndex + 1);
    }
  }

  function convertJSONToCSV(jsonData, columnHeaders) {
    if (jsonData.length === 0) {
      return '';
    }

    const headers = columnHeaders.join(',') + '\n';
    const rows = jsonData
      .map((row) => {
        return columnHeaders.map((field) => row[field] || '').join(',');
      })
      .join('\n');

    return headers + rows;
  }

  async function downloadCSV() {
    var headers = [
      'productitem_id',
      'productitem_name',
      'productitem_inter',
      'productitem_desc',
      'productitem_weight',
      'productitem_width',
      'productitem_height',
      'productitem_deep',
      'productitem_barcode',
      'createtime',
      'edittime',
      'useredit',
    ];

    setExportLoading(true);
    try {
      const allItems = await fetchAllProductItems({
        appHostname: props.app_hostname,
        token: props.permitdata.token,
      });
      let exportItems = allItems;
      if (productcategory_selected && productcategory_selected !== 'all') {
        exportItems = allItems.filter(
          (item) => item.productcategory_id === productcategory_selected,
        );
      }
      if (debouncedSearch) {
        const search = debouncedSearch.toLowerCase();
        exportItems = exportItems.filter(
          (item) =>
            item.productitem_id?.toLowerCase().includes(search) ||
            item.productitem_name?.toLowerCase().includes(search) ||
            item.productitem_inter?.toLowerCase().includes(search) ||
            (item.productitem_barcode &&
              item.productitem_barcode.toLowerCase().includes(search)),
        );
      }

      const csvData = convertJSONToCSV(exportItems, headers);
      var rs = productcategory_list.filter(
        (item) => item.productcategory_id === productcategory_selected,
      );

      if (csvData === '') {
        message.warning('ไม่มีข้อมูลสำหรับส่งออก');
      } else {
        const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        const categoryName =
          rs.length > 0 ? rs[0].productcategory_name : productcategory_selected === 'all' ? 'all' : 'unknown';
        link.setAttribute('download', 'meya_item_' + categoryName + '.csv');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    } catch (err) {
      message.error(err.message || 'ส่งออกข้อมูลไม่สำเร็จ');
    } finally {
      setExportLoading(false);
    }
  }

  function callback_editproduct(item) {
    handleEdit(item);
    setPreview_Option({});
  }

  const columns = [
    {
      title: '#',
      key: 'index',
      width: 60,
      render: (_, __, index) => (page - 1) * pageSize + index + 1,
    },
    {
      title: 'รูปสินค้า',
      key: 'product_image',
      width: 88,
      align: 'center',
      render: (_, record) => (
        <button
          type='button'
          className='product-table-thumb'
          onClick={() => handleEdit(record)}
          title='แก้ไขสินค้า'
        >
          <img
            src={getProductImageUrl(record, 1)}
            alt={record.productitem_name || 'รูปสินค้า'}
            onError={(e) => {
              e.target.src = '/images/blank.png';
            }}
          />
        </button>
      ),
    },
    {
      title: 'รหัสสินค้า / บาร์โค้ด',
      key: 'id_barcode',
      width: 140,
      sorter: (a, b) => a.productitem_id?.localeCompare(b.productitem_id),
      render: (_, record) => (
        <Space direction='vertical' size={0}>
          <Text strong>{record.productitem_id}</Text>
          <Text type='secondary' style={{ fontSize: '12px' }}>
            {record.productitem_barcode}
          </Text>
        </Space>
      ),
    },
    {
      title: 'ชื่อสินค้า (ไทย/อังกฤษ)',
      key: 'name',
      sorter: (a, b) => a.productitem_name?.localeCompare(b.productitem_name),
      render: (_, record) => (
        <Space direction='vertical' size={0}>
          <Text strong>{record.productitem_name}</Text>
          <Text type='secondary' style={{ fontSize: '12px' }}>
            {record.productitem_inter}
          </Text>
        </Space>
      ),
    },
    {
      title: 'ความกว้าง (cm)',
      dataIndex: 'productitem_width',
      key: 'productitem_width',
      width: 100,
      align: 'right',
      sorter: (a, b) => Number(a.productitem_width) - Number(b.productitem_width),
    },
    {
      title: 'ความยาว (cm)',
      dataIndex: 'productitem_height',
      key: 'productitem_height',
      width: 100,
      align: 'right',
      sorter: (a, b) => Number(a.productitem_height) - Number(b.productitem_height),
    },
    {
      title: 'ความสูง (cm)',
      dataIndex: 'productitem_deep',
      key: 'productitem_deep',
      width: 100,
      align: 'right',
      sorter: (a, b) => Number(a.productitem_deep) - Number(b.productitem_deep),
    },
    {
      title: 'น้ำหนัก (g)',
      dataIndex: 'productitem_weight',
      key: 'productitem_weight',
      width: 100,
      align: 'right',
      sorter: (a, b) => Number(a.productitem_weight) - Number(b.productitem_weight),
    },
    {
      title: 'จัดการ',
      key: 'action',

      width: 220,
      align: 'center',
      render: (_, record) => (
        <Space>
          <Button icon={<EyeOutlined />} size='small' onClick={() => setPreview_Option(record)}>
            ดูตัวอย่าง
          </Button>
          <Button
            type='primary'
            icon={<EditOutlined />}
            size='small'
            onClick={() => handleEdit(record)}
          >
            แก้ไข
          </Button>
          <Popconfirm
            title='ยืนยันการลบ'
            description='คุณแน่ใจหรือไม่ที่จะลบรายการนี้?'
            onConfirm={() => handleDelete(record)}
            okText='Yes'
            cancelText='No'
          >
            <Button type='primary' danger icon={<DeleteOutlined />} size='small'>
              ลบ
            </Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  const renderMobileList = () => (
    <div className='product-list-container-mobile'>
      {productitem_list.map((record, index) => (
        <div
          key={record.productitem_id}
          className='product-item-card animate-fade-up'
          style={{ animationDelay: `${index * 0.05}s` }}
        >
          <div className='product-item-image-container'>
            <img
              src={getProductImageUrl(record, 1)}
              alt={record.productitem_name}
              onError={(e) => {
                e.target.src = '/images/blank.png';
              }}
            />
          </div>
          <div className='product-item-info'>
            <div className='product-item-id-badge'>{record.productitem_id}</div>
            <div className='product-item-name'>{record.productitem_name}</div>
            <div className='product-item-detail' style={{ marginTop: '4px', fontSize: '11px' }}>
              Barcode: {record.productitem_barcode}
            </div>
          </div>
          <div className='product-item-actions-mobile'>
            <Button
              className='btn-mobile-action'
              onClick={() => setPreview_Option(record)}
              size='small'
            >
              ดูตัวอย่าง
            </Button>
            <Button
              type='primary'
              className='btn-mobile-action'
              onClick={() => handleEdit(record)}
              size='small'
            >
              แก้ไข
            </Button>
            <Popconfirm
              title='ยืนยันการลบ'
              onConfirm={() => handleDelete(record)}
              okText='Yes'
              cancelText='No'
            >
              <Button danger type='primary' className='btn-mobile-action' size='small'>
                ลบ
              </Button>
            </Popconfirm>
          </div>
        </div>
      ))}
    </div>
  );

  const renderGallery = () => (
    <div className='product-gallery-grid'>
      {productitem_list.map((record, index) => (
        <div
          key={record.productitem_id}
          className='animate-fade-up'
          style={{ animationDelay: `${index * 0.05}s` }}
        >
          <CardProductDemo
            shopitem={record}
            show_stock={false}
            show_shop={true}
            callback_editproduct={(item) => handleEdit(item)}
          />
        </div>
      ))}
    </div>
  );

  return (
    <div className='page-wrapper'>
      <div className='page-card'>
        <Space direction='vertical' size='large' style={{ width: '100%' }}>
          <div className='page-header-actions'>
            <div style={{ marginBottom: props.isMobile ? '12px' : 0 }}>
              <Title level={props.isMobile ? 4 : 3} style={{ margin: 0 }}>
                <TagOutlined style={{ color: '#fa8c16', marginRight: '8px' }} />
                รายการสินค้า
              </Title>
              <Text type='secondary'>จัดการรายการสินค้าทั้งหมด</Text>
            </div>
            <Space
              size={props.isMobile ? 'small' : 'middle'}
              wrap
              style={{ width: props.isMobile ? '100%' : 'auto' }}
            >
              {props.isMobile && (
                <Select
                  value={viewMode}
                  onChange={setViewMode}
                  style={{ width: 100 }}
                  options={[
                    { label: 'รายการ', value: 'list' },
                    { label: 'แกลลอรี่', value: 'gallery' },
                  ]}
                />
              )}
              <Button
                icon={<PlusOutlined />}
                type='primary'
                onClick={handleAdd}
                block={props.isMobile}
              >
                เพิ่มใหม่
              </Button>
               {/* Deferred (bulk import UI): restore to show เพิ่มใหม่หลายรายการ */}
              {/* <Button
                icon={<ImportOutlined />}
                type='primary'
                className='btn-add-multiple'
                block={props.isMobile}
                onClick={() => setIsImportModalOpen(true)}
              >
                เพิ่มใหม่หลายรายการ
              </Button> */}
             
              <Button
                icon={<ReloadOutlined />}
                onClick={reload}
                loading={loading}
                block={props.isMobile}
              >
                รีเฟรช
              </Button>
              <Button icon={<FileExcelOutlined />} onClick={downloadCSV} loading={exportLoading} block={props.isMobile}>
                ส่งออก
              </Button>
            </Space>
          </div>

          <Row gutter={[16, 16]} align='middle'>
            <Col xs={24} md={8} lg={6}>
              <Text strong>หมวดหมู่:</Text>
              <Select
                value={productcategory_selected || 'all'}
                onChange={(value) => {
                  setProductCategory_Selected(value);
                  setFiltertext('');
                  setPage(1);
                }}
                style={{ width: '100%', marginTop: '8px' }}
                options={[
                  { label: 'ทั้งหมด', value: 'all' },
                  ...(productcategory_list || []).map((c) => ({
                    label: c.productcategory_name,
                    value: c.productcategory_id,
                  })),
                ]}
              />
            </Col>
            <Col xs={24} md={16} lg={12}>
              <Text strong>ค้นหาสินค้า:</Text>
              <Input
                placeholder='รหัสสินค้า, ชื่อสินค้า (ไทย/อังกฤษ), บาร์โค้ด'
                value={filtertext}
                onChange={(e) => setFiltertext(e.target.value)}
                allowClear
                prefix={<SearchOutlined />}
                suffix={
                  <Button
                    type='text'
                    size='small'
                    icon={<ScanOutlined style={{ color: '#fa8c16', fontSize: '16px' }} />}
                    onClick={() => setIsSearchScannerOpen(true)}
                    title='สแกนบาร์โค้ดเพื่อค้นหา'
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      border: 'none',
                      padding: '4px',
                      height: 'auto',
                    }}
                  />
                }
                style={{ width: '100%', marginTop: '8px' }}
              />
            </Col>
          </Row>

          <div>
            <Title level={5} style={{ marginBottom: '16px' }}>
              รายการสินค้า <span>({total} รายการ)</span>
            </Title>
            {props.isMobile ? (
              <>
                {viewMode === 'list' ? renderMobileList() : renderGallery()}
                {total > pageSize ? (
                  <Pagination
                    current={page}
                    pageSize={pageSize}
                    total={total}
                    onChange={(nextPage) => setPage(nextPage)}
                    style={{ marginTop: 16, textAlign: 'center' }}
                    size='small'
                  />
                ) : null}
              </>
            ) : (
              <Table
                className='product-item-table'
                columns={columns}
                dataSource={productitem_list}
                rowKey='productitem_id'
                loading={loading}
                rowClassName={(_, index) =>
                  index % 2 === 0 ? 'product-table-row-odd' : 'product-table-row-even'
                }
                pagination={{
                  current: page,
                  pageSize,
                  total,
                  showTotal: (itemTotal) => `ทั้งหมด ${itemTotal} รายการ`,
                  onChange: (nextPage) => setPage(nextPage),
                }}
                scroll={{ x: 'max-content' }}
              />
            )}
          </div>
        </Space>
      </div>

      <Modal
        title={
          <Space>
            <TagOutlined />
            {productmode === 'add' ? 'เพิ่มสินค้า' : 'แก้ไขสินค้า'}
          </Space>
        }
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={null}
        width={props.isMobile ? '95%' : 1000}
        centered
      >
        <Form form={form} layout='vertical' onFinish={handleSubmit} style={{ marginTop: '24px' }}>
          <Row gutter={[16, 16]}>
            <Col xs={24} md={10}>
              <div className='product-image-grid'>
                <div className='upload-box main'>
                  <img src={PreviewImage1} alt='Product 1' />
                  <input type='file' accept='image/*' onChange={handleImageChange1} />
                  {!imageFile1 && productmode === 'add' && (
                    <div className='upload-placeholder'>
                      <PlusOutlined />
                      <span>รูปหลัก</span>
                    </div>
                  )}
                </div>
                <div className='upload-box'>
                  <img src={PreviewImage2} alt='Product 2' />
                  <input type='file' accept='image/*' onChange={handleImageChange2} />
                  {!imageFile2 && productmode === 'add' && (
                    <div className='upload-placeholder'>
                      <PlusOutlined />
                      <span>รูป 2</span>
                    </div>
                  )}
                </div>
                <div className='upload-box'>
                  <img src={PreviewImage3} alt='Product 3' />
                  <input type='file' accept='image/*' onChange={handleImageChange3} />
                  {!imageFile3 && productmode === 'add' && (
                    <div className='upload-placeholder'>
                      <PlusOutlined />
                      <span>รูป 3</span>
                    </div>
                  )}
                </div>
              </div>
              <div className='upload-instructions'>
                <div className='instructions-title'>
                  <PlusOutlined style={{ color: '#fa8c16' }} />
                  <span>คำแนะนำในการอัปโหลดรูปภาพ</span>
                </div>
                <ul>
                  <li>รูปภาพแรก (รูปหลัก) จะถูกใช้เป็นหน้าปกหลักของสินค้า</li>
                  <li>ขนาดไฟล์ภาพแนะนำไม่เกิน 2MB ต่อรูปภาพ</li>
                  <li>สัดส่วนภาพที่แนะนำคือ 1:1 หรือ 4:3 เพื่อการแสดงผลที่สวยที่สุด</li>
                  <li>รองรับประเภทไฟล์รูปภาพ JPG, JPEG, PNG หรือ WebP</li>
                </ul>
              </div>
            </Col>

            <Col xs={24} md={14}>
              <Form.Item name='productitem_id' label='รหัสสินค้า'>
                <Input disabled />
              </Form.Item>
              <div className='drug-license-field'>
                <div className='drug-license-header'>
                  <span className='drug-license-label'>
                    <span className='drug-license-required'>*</span> ทะเบียนยา
                  </span>
                  <Link
                    className='drug-license-manage-link'
                    to={
                      selectedCategoryId
                        ? `/product/category/license?id=${encodeURIComponent(selectedCategoryId)}`
                        : '/product/category/license'
                    }
                  >
                    จัดการสิทธิ์ทะเบียนยา
                  </Link>
                </div>
                <div className='drug-license-badges'>
                  {selectedProductLicenses.map((label) => (
                    <Tag key={label} className='drug-license-badge'>
                      {label}
                    </Tag>
                  ))}
                </div>
              </div>
              <Row gutter={16}>
                <Col xs={24} sm={12}>
                  <Form.Item
                    name='productcategory_id'
                    label='หมวดหมู่สินค้า'
                    rules={[{ required: true, message: 'กรุณาเลือกหมวดหมู่' }]}
                  >
                    <Select
                      options={(productcategory_list || []).map((c) => ({
                        label: c.productcategory_name,
                        value: c.productcategory_id,
                      }))}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12}>
                  <Form.Item
                    name='productitem_barcode'
                    label='บาร์โค้ด'
                    rules={[
                      { required: true, message: 'กรุณากรอก Barcode' },
                      { min: 5, message: 'Barcode ต้องมีอย่างน้อย 5 ตัวอักษร' },
                    ]}
                  >
                    <Input
                      suffix={
                        <Button
                          type='text'
                          size='small'
                          icon={<ScanOutlined style={{ color: '#fa8c16', fontSize: '16px' }} />}
                          onClick={() => setIsScannerOpen(true)}
                          title='สแกนบาร์โค้ด'
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            border: 'none',
                            padding: '4px',
                            height: 'auto',
                          }}
                        />
                      }
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Form.Item
                name='productitem_name'
                label='ชื่อสินค้า (ไทย)'
                rules={[
                  { required: true, message: 'กรุณากรอกชื่อสินค้า (ไทย)' },
                  { min: 5, message: 'ชื่อสินค้าต้องมีอย่างน้อย 5 ตัวอักษร' },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                name='productitem_inter'
                label='ชื่อสินค้า (อังกฤษ)'
                rules={[
                  { required: true, message: 'กรุณากรอกชื่อสินค้า (อังกฤษ)' },
                  { min: 5, message: 'ชื่อสินค้าต้องมีอย่างน้อย 5 ตัวอักษร' },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                name='productitem_desc'
                label='รายละเอียดสินค้า'
                rules={[
                  { required: true, message: 'กรุณากรอกรายละเอียดสินค้า' },
                  { min: 5, message: 'รายละเอียดสินค้าต้องมีอย่างน้อย 5 ตัวอักษร' },
                ]}
              >
                <Input.TextArea rows={4} />
              </Form.Item>

              {/* Deferred (expire/lot UI): restore when enabling master expire/lot fields
              <Row gutter={16}>
                <Col xs={24} sm={12}>
                  <Form.Item
                    name='productitem_expiredate'
                    label='วันที่หมดอายุ'
                    rules={[{ required: true, message: 'กรุณาเลือกวันที่หมดอายุ' }]}
                  >
                    <ResponsiveDatePicker
                      format='DD MMM BBBB'
                      style={{ width: '100%' }}
                      placeholder='เลือกวันที่หมดอายุ'
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12}>
                  <Form.Item
                    name='productitem_lot'
                    label='ล๊อตสินค้า'
                    rules={[{ required: true, message: 'กรุณากรอกล๊อตสินค้า' }]}
                  >
                    <Input placeholder='เช่น 01A' />
                  </Form.Item>
                </Col>
              </Row>
              */}

              <Text strong>ขนาดสินค้า</Text>
              <Row gutter={[8, 8]} style={{ marginTop: '8px' }}>
                <Col xs={12} sm={6}>
                  <Form.Item
                    name='productitem_width'
                    label='ความกว้าง (cm)'
                    rules={[{ required: true, message: 'กรุณากรอกความกว้าง' }]}
                  >
                    <InputNumber min={0.01} step={0.01} style={{ width: '100%' }} />
                  </Form.Item>
                </Col>
                <Col xs={12} sm={6}>
                  <Form.Item
                    name='productitem_height'
                    label='ความยาว (cm)'
                    rules={[{ required: true, message: 'กรุณากรอกความยาว' }]}
                  >
                    <InputNumber min={0.01} step={0.01} style={{ width: '100%' }} />
                  </Form.Item>
                </Col>
                <Col xs={12} sm={6}>
                  <Form.Item
                    name='productitem_deep'
                    label='ความสูง (cm)'
                    rules={[{ required: true, message: 'กรุณากรอกความสูง' }]}
                  >
                    <InputNumber min={0.01} step={0.01} style={{ width: '100%' }} />
                  </Form.Item>
                </Col>
                <Col xs={12} sm={6}>
                  <Form.Item
                    name='productitem_weight'
                    label='น้ำหนัก (g)'
                    rules={[{ required: true, message: 'กรุณากรอกน้ำหนัก' }]}
                  >
                    <InputNumber min={0.01} step={0.01} style={{ width: '100%' }} />
                  </Form.Item>
                </Col>
              </Row>

              <div
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  gap: '8px',
                  marginTop: '24px',
                }}
              >
                <Button onClick={() => setIsModalOpen(false)}>ยกเลิก</Button>
                <Button type='primary' htmlType='submit' loading={modalLoading}>
                  บันทึก
                </Button>
              </div>
            </Col>
          </Row>
        </Form>
      </Modal>

      {preview_option.productitem_id !== undefined && (
        <Modal
          open={!!preview_option.productitem_id}
          onCancel={() => setPreview_Option({})}
          footer={null}
          width={props.isMobile ? '90%' : 450}
          centered
          className='product-preview-modal'
        >
          <div className='preview-container'>
            <div className='preview-image-box'>
              <img
                src={getProductImageUrl(preview_option, 1)}
                alt={preview_option.productitem_name}
              />
            </div>
            <div className='preview-info'>
              <div className='product-item-id-badge'>{preview_option.productitem_id}</div>
              <div className='preview-name-th'>{preview_option.productitem_name}</div>
              <div className='preview-name-en'>{preview_option.productitem_inter}</div>
            </div>
            <Button
              block
              danger
              type='primary'
              ghost
              style={{ marginTop: '24px', borderRadius: '8px', height: '40px' }}
              onClick={() => setPreview_Option({})}
            >
              ปิด
            </Button>
          </div>
        </Modal>
      )}

      <ProductImportModal
        isOpen={isImportModalOpen}
        onClose={() => {
          setIsImportModalOpen(false);
          setImportFile(null);
        }}
        onFileSelected={setImportFile}
        onImported={reload}
        appHostname={props.app_hostname}
        token={props.permitdata?.token}
        username={props.permitdata?.username}
        categories={productcategory_list}
        existingProducts={productitem_list}
      />

      {isScannerOpen && (
        <BarcodeScanner
          onScanSuccess={(code) => {
            setIsScannerOpen(false);
            form.setFieldsValue({ productitem_barcode: code.trim() });
            message.success(`สแกนบาร์โค้ดสำเร็จ: ${code}`);
          }}
          onClose={() => setIsScannerOpen(false)}
        />
      )}

      {isSearchScannerOpen && (
        <BarcodeScanner
          onScanSuccess={(code) => {
            setIsSearchScannerOpen(false);
            setFiltertext(code.trim());
            message.success(`สแกนเพื่อค้นหาสำเร็จ: ${code}`);
          }}
          onClose={() => setIsSearchScannerOpen(false)}
        />
      )}
    </div>
  );
}

export default ProductItem;
